import React, {Fragment} from "react";
import {Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import {traversePropertiesArray} from '../shared/shared';

export function AgentInfo(props) {
  const {values, handleCB, readonly, token, formFields,agentdata} = props;

  function setAgentFormFieldValueFromList(field, value, type) {
    if (readonly) return;
    var objPost = {
      ...values,
      [type]: {
        [field]: value,
        ...agentdata.filter(ad => ad.id.toString() === value.toString())[0].customData
      },
    }
    handleCB(objPost);
  };

  function setAgentFormFieldValueFromText(field, value, type) {
    if (readonly) return;
    if (!values.hasOwnProperty(type)) values[type] = {};
    var objPost = {
      ...values,
      [type]: {
        ...values[type],
        [field]: value
      },
    }
    handleCB(objPost);
  };

  function getFormFieldValue(val) {
    if (val != null) {
      return val;
    } else {
      return "";
    }
  };

  function customizeAgent(e, type) {
    e.preventDefault();
    if (readonly) return;
    var objPost = {
      ...values
    }
    delete (objPost[type]['agentOption']);
    console.log(objPost);
    handleCB(objPost);
  }

  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h2>Agent Information</h2>
        </Col>
      </Row>
      {traversePropertiesArray(formFields, ['basic', 'selectedApps']).length > 0 ?
        <Fragment>
          {traversePropertiesArray(formFields, ['basic', 'selectedApps']).indexOf("MBA") > -1 && (
            <Fragment>
              <Row>
                <Col xs={"2"}>
                  <h4>MBA</h4>
                </Col>
                {agentdata.filter(ad => ad.applicationType === "MBA").length > 0 && (
                  <Col xs={3}>
                    <FormGroup>
                      <Label htmlFor="agentOption">Agent</Label>
                      <Input type="select" name="agentOption" id="agentOption"
                             value={getFormFieldValue(values['MBA'] ? values['MBA']['agentOption'] : null)}
                             onChange={(evt) => setAgentFormFieldValueFromList(evt.target.id, evt.target.value, "MBA")}>
                        <option key={0} value={""} disabled={true}>Select...</option>
                        {agentdata.filter(ad => ad.applicationType === "MBA").map((coverage, index) => {
                          return (
                            <option key={index + 1} value={coverage.id}>{coverage.display}</option>
                          )
                        })}
                      </Input>
                      {getFormFieldValue(values['MBA'] ? values['MBA']['agentOption'] : null).length > 0 && (
                        <a href="javascript:void(0);" onClick={(e) => customizeAgent(e, "MBA")}>Customize</a>
                      )}
                      <FormText color="muted">
                        Choose from list or input custom values below:
                      </FormText>
                    </FormGroup>
                  </Col>
                )}
              </Row>
              {getFormFieldValue(values['MBA'] ? values['MBA']['agentOption'] : null).length === 0 && (
                <Row>
                  <Col xs={"3"}>
                    <FormGroup>
                      <Label htmlFor="name">Name*</Label>
                      <Input type="text" id="name" placeholder=""
                             value={getFormFieldValue(values['MBA'] ? values['MBA']['name'] : null)}
                             onChange={(evt) => setAgentFormFieldValueFromText( evt.target.id, evt.target.value,"MBA")}/>
                    </FormGroup>
                  </Col>
                  <Col xs={"3"}>
                    <FormGroup>
                      <Label htmlFor="phone">Phone*</Label>
                      <TextMask
                        mask={[/[2-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        Component={InputAdapter}
                        className="form-control"
                        id="phone"
                        value={getFormFieldValue(values['MBA'] ? values['MBA']['phone'] : null)}
                        onChange={(evt) => setAgentFormFieldValueFromText(evt.target.id, evt.target.value,"MBA")}
                      />
                      <FormText color="muted">
                        ###-###-####
                      </FormText>
                    </FormGroup>
                  </Col>
                  <Col xs={"2"}>
                    <FormGroup>
                      <Label htmlFor="code">Agent&nbsp;Code*</Label>
                      <Input type="text" id="code" placeholder=""
                             value={getFormFieldValue(values['MBA'] ? values['MBA']['code'] : null)}
                             onChange={(evt) => setAgentFormFieldValueFromText(evt.target.id, evt.target.value,"MBA")}/>
                    </FormGroup>
                  </Col>
                  <Col xs={"2"}>
                    <FormGroup>
                      <Label htmlFor="agencyCode">Agency&nbsp;Code*</Label>
                      <Input type="text" id="agencyCode"
                             value={getFormFieldValue(values['MBA'] ? values['MBA']['agencyCode'] : null)}
                             onChange={(evt) => setAgentFormFieldValueFromText( evt.target.id, evt.target.value,"MBA")}/>
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </Fragment>
          )}
        </Fragment>
        :
        <Row>
          <Col xs={"12"}>
            <h5>Choose an application first from the Basic Info section</h5>
          </Col>
        </Row>
      }

    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/AgentInfo.js